import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { PercentageTextBoxEditor } from "../../../../../../../react-core/Html/PercentageTextBoxEditor";
import { isNullOrEmpty } from "../../../../../../../react-core/Utils/Arrays";
import { InvestmentAllocation } from "../../../../../../../Wrap/Models/Domains/Investment/InvestmentAllocation";
import { User } from "../../../../../../../Wrap/Models/Models/User/User";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { Table } from "../../../../../../Shared/Table/Table";
import { UserStore } from "../../../../../Stroes/Variable";
import { ChooseAssetsToSwitchAssets } from "./Store/DrawdownCalculationStoreStatic";
import { DrawdownSwitchValidationMessage } from "./Resource/Contents";
import { ProductType } from "../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { InvestmentDetailsPopupModal } from "../../InvestmentDetailsPopUp/InvestmentDetailsPopupModal";
import { InvestmentSelectionAction } from "../../../../../../Shared/IST/Action/InvestmentSelectionAction";
import { Investment } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/Investment";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import AriaTooltip from "../../../../../../Shared/Tooltip/AriaTooltip";
import { treasureAssetTooltip } from "../../../Sell/Resource/Content";
import { CheckboxEditor } from "../../../../../../../react-core/Html/CheckboxEditor";
import { ClientAccountStore, TreasuredAssetsStore } from "../../../../../../../applications/Dashboard/Stroes/Variable";
import { SubAccountTypeHelper } from "../../Helpers/SubAccountTypeHelper";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { ServiceProposition } from "../../../../../../../Wrap/Constants/Enums/ServiceProposition";

interface ISwitchToAllocationTableProps extends IProcessComponentProps {
    data: InvestmentAllocation[];
    tableData: ChooseAssetsToSwitchAssets[];
    switchMaxValue:number;
    onTableDataDelete: (changes, productId) => void;
    onTreasuredAssetChange: Function;
    ChecktreasuredAsset: Array<number>;
}

interface ISwitchToAllocationState {
    userInfo: User;

    isShowDetailModal: boolean;
    selectedInvestment: Investment;
}

export class SwitchToAllocationTable extends ProcessComponent<
    ISwitchToAllocationTableProps,
    ISwitchToAllocationState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            userInfo: UserStore.getUserInfo(),
            isShowDetailModal: false,
            selectedInvestment: null,
        };
    }

    private onAssetsChanges(row: ChooseAssetsToSwitchAssets, v: number) {
        const i = this.props.data.findIndex((ele) => ele.ProductId == row.ProductId);
        const _data = this.props.data.concat();
        if (i > -1) {
            _data[i].Percentage = v;
        } else {
            _data.push({ Name: row.Assets, Percentage: v, ProductId: row.ProductId, Type: row.ProductType });
        }
        this.props.onChange(_data);
    }

    private treasureAsset = (v: boolean, code) => {
        const _data: any[] = this.props.data.concat();
        const ele = _data.find((ele) => ele.ProductId == code);

        this.props.onTreasuredAssetChange(v, ele.ProductId);
    };

    isValid() {
        const total = this.props.data?.reduce((sum, curr) => {
            return (sum = sum + curr.Percentage);
        }, 0);
        if (total !== 100) {
            this.props.showErrorMsgPopUp([DrawdownSwitchValidationMessage.total100]);
        }
        return super.isValid() && total == 100;
    }

    private onInvestmentSelected(investment) {
        InvestmentSelectionAction.getUnitPrice(investment, (d) => {
            this.setState({ selectedInvestment: d, isShowDetailModal: true });
        });
    }

    private renderInvestmentDetailPopupModal(): JSX.Element {
        const { isShowDetailModal, selectedInvestment } = this.state;

        if (!isShowDetailModal) return null;
        return (
            <>
                <InvestmentDetailsPopupModal
                    showBox={isShowDetailModal}
                    callBack={() => {
                        this.setState({ isShowDetailModal: false });
                    }}
                    instrumentCode={selectedInvestment?.InstrumentCode}
                    productId={selectedInvestment?.ProductId}
                    instrumentName={selectedInvestment?.DisplayName}
                    unitCost={selectedInvestment?.UnitCost}
                    securityType={selectedInvestment?.Type}
                    unitPrice={selectedInvestment?.UnitPrice}
                />
            </>
        );
    }

    public render(): JSX.Element {
        const { data, tableData } = this.props;
        if (isNullOrEmpty(tableData))
            return <Alert alertType={AlertType.Warning} message={"No investments have been selected."} />;
        
        const total = data?.reduce((sum, curr) => {
            return (sum = sum + curr.Percentage);
        }, 0);

        let totalValue = this.props.switchMaxValue;
        let _tableData = tableData.concat();

        return (
            <>
                <Table
                    data={_tableData}
                    col={[
                        {
                            title: "Assets",
                            key: "Assets",
                            thCssWrapper: "cell-left cell-40 pr-0",
                            tdCssWrapper: "cell-left cell-40 pr-0",
                            render: (data, row: ChooseAssetsToSwitchAssets, index) => {
                                if (
                                    [
                                        ProductType.ManagedModelPortfolio,
                                        ProductType.TailoredModelPortfolio,
                                        ProductType.AdviserModelPortfolio,
                                    ].includes(row.ProductType)
                                )
                                    return data;

                                return (
                                    <a className="hyperlink" onClick={() => this.onInvestmentSelected(row)}>
                                        {data}
                                    </a>
                                );
                            },
                        },
                        {
                            title: "Allocation",
                            key: "ProductId",
                            thCssWrapper: "cell-left cell-15 pr-0",
                            tdCssWrapper: "cell-right cell-15 pr-0",
                            render: (data, row: ChooseAssetsToSwitchAssets, index) => {
                                const percentage =
                                    this.props.data.find((ele) => ele.ProductId == row.ProductId)?.Percentage || null;
                                return (
                                    <PercentageTextBoxEditor
                                        value={percentage}
                                        onChange={(v) => this.onAssetsChanges(row, v)}
                                        maxNumberOfDecimalPlaces={{
                                            errorMessage: DrawdownSwitchValidationMessage.allowDecimals,
                                            value: 2,
                                        }}
                                        validationRules={[
                                            {
                                                errorMessage: DrawdownSwitchValidationMessage.moreThan100PercentSwitchTo,
                                                validator: (v) => {
                                                    return v <= 100;
                                                },
                                            }
                                        ]}
                                        infoText={MoneyDisplayHelper.getMoneyFormat({
                                            Amount: (percentage || 0) * totalValue * 0.01,
                                        })
                                        }
                                    />                                );
                            },
                        },

                        !SubAccountTypeHelper.isLegacyProduct(
                            ClientAccountStore.getClientAccountInfo()?.SubAccounts?.find(
                                (ele) => ele.HierarchyId == getQueryParameters()?.["subaccounthierarchyid"]
                            )?.SubAccountType
                        ) &&
                            ClientAccountStore.getClientAccountInfo()?.AccountServicePropositionId == ServiceProposition.Wrap
                            ? {
                                title: (
                                    <span>
                                        Protect from auto-disinvestment?
                                        <AriaTooltip cssWrapper="is-info-icon ml-6">{treasureAssetTooltip}</AriaTooltip>
                                    </span>
                                ),
                                key: "isTreasuredAsset",
                                thCssWrapper: "cell-right cell-30 pr-0",
                                tdCssWrapper: "cell-right cell-30 pr-0",
                                render: (data, row) => {
                                    if (row.ProductType != ProductType.CashProduct) {
                                        return (
                                            <CheckboxEditor
                                                cssWrapper={"square-checkbox mb-0"}
                                                onChange={(v) => this.treasureAsset(v, row.ProductId)}
                                                value={this.props.ChecktreasuredAsset?.includes(row.ProductId)}
                                                disabled={(TreasuredAssetsStore.getTreasuredAssetsProductIds() || [])?.includes(
                                                    row.ProductId
                                                )}
                                            />
                                        );
                                    } else {
                                        return (
                                            <span>N/A</span>
                                        );
                                    }
                                },
                            }
                            : null,
                        {
                            title: "Action",
                            key: "Action",
                            thCssWrapper: "cell-right cell-30 pr-0",
                            tdCssWrapper: "cell-right cell-30 pr-0",
                            render: (data, row) => {
                                return (
                                    <button
                                        className="remove-button label-sr-only"
                                        title="Delete"
                                        onClick={() => this.props.onTableDataDelete(-1, row.ProductId)}
                                    >
                                        <span className="icon" aria-hidden="true"></span>
                                        <span className="text">remove</span>
                                    </button>
                                );
                            },
                        }
                    ]}
                    TotalBody={[
                        { data: "Total", colSpan: 1 },
                        {
                            data: (
                                <div style={{ textAlign: 'right' }}>
                                    <span className={total === 100 ? "text-positive" : "text-text"}>
                                        {total}%
                                    </span>
                                </div>
                            ),
                            colSpan: 1,
                        },
                        { data: "", colSpan: 2 }
                    ]}
                />
                { this.renderInvestmentDetailPopupModal()}
            </> 
        );
    }
}
